/**
 * @phxAuthToken
 */
export interface IAuthToken {
  getToken(): ng.IPromise<string>;
  campusTokenRequest(config: any): ng.IPromise<string>;
}

export interface IAuthTokenProvider {
  configure(config: IAuthTokenConfig): IAuthTokenConfig;
}

export interface IAuthTokenConfig {
  tokenExpiryTime: number;
  authTokenApi: string;
}

interface IAuthTokenResponseData {
  access_token: string;
}

class AuthToken implements IAuthToken {
  private static ONE_SECOND: number = 1000;
  private _expirationTimer: number = 0;
  private _hasExpired: boolean = true;
  private _token: string = '';

  constructor(
    private $http: ng.IHttpService,
    private $q: ng.IQService,
    private appConfigModel: any,
    private _configuration: IAuthTokenConfig
  ) {}

  public getToken(): ng.IPromise<string> {
    const deferred: ng.IDeferred<string> = this.$q.defer();

    if (!this._hasExpired) {
      deferred.resolve(this._token);
      return deferred.promise;
    }

    this.$http
      .get(this._configuration.authTokenApi)
      .then((response: ng.IHttpPromiseCallbackArg<{}>): void => {
        const res: IAuthTokenResponseData = (response.data || {}) as IAuthTokenResponseData;

        this._token = res.access_token;
        this._resetExpirationTimer();

        deferred.resolve(this._token);
      })
      .catch((reason: string): void => {
        deferred.reject(reason);
      });

    return deferred.promise;
  }

  public campusTokenRequest(requestConfig: any): ng.IPromise<string> {
    const deferred: ng.IDeferred<string> = this.$q.defer();

    this.getToken()
      .then((token: string): any => {
        let config: any = {
          url: '',
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + token,
            isCampusAPI: true
          }
        };

        config = _.merge(config, requestConfig);
        config.url = this.appConfigModel.getConfigProperty('core-campus_url') + requestConfig.url;
        this.$http(config)
          .then((response: ng.IHttpPromiseCallbackArg<{}>) => {
            deferred.resolve(response.data as string);
          })
          .catch((error: any): void => {
            deferred.reject(error);
          });
      })
      .catch((error: any): void => {
        deferred.reject(error);
      });

    return deferred.promise;
  }

  private _resetExpirationTimer(): void {
    clearTimeout(this._expirationTimer);
    this._hasExpired = false;

    this._expirationTimer = window.setTimeout(() => {
      clearTimeout(this._expirationTimer);
      this._hasExpired = true;
    }, this._configuration.tokenExpiryTime * AuthToken.ONE_SECOND);
  }
}

class AuthTokenProvider implements IAuthTokenProvider {
  private _configuration: IAuthTokenConfig;
  private static DEFAULTS: IAuthTokenConfig = {
    tokenExpiryTime: 60,
    authTokenApi: ''
  };

  constructor() {
    this.configure(AuthTokenProvider.DEFAULTS);
  }

  public configure(config: IAuthTokenConfig): IAuthTokenConfig {
    this._configuration = _.merge(AuthTokenProvider.DEFAULTS, config);
    return this._configuration;
  }

  public $get($http: ng.IHttpService, $q: ng.IQService, appConfigModel: any): IAuthToken {
    return new AuthToken($http, $q, appConfigModel, this._configuration);
  }
}

angular.module('utility-ng-auth-token', []).provider('authToken', AuthTokenProvider);

export default 'utility-ng-auth-token';



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-auth-token/src/main.ts